const langtrans={
      sy:["首页","Homepage"],
      ddjx:["大救星","Dajiuxing"],
      hgzzzz:["合作咨询","Partnership"],
      dl:["登录","Log in"],
      jyjgrk:["救援机构入口","Assistance agencies"],
      jjgjgr:["监管机构入口","Regulators"],
      zzzhzz:["指挥中心入口","The command center"],
      ddjxjy:["大救星救援云平台","DaJiuXing Assistance Platform"],
      qsr:["请输入","Please enter  "],
      qsrmm:["请输入密码","Please enter the password"],
      qsrcode:["请输入验证码","Please enter the code"],
      qx:["取消","cancel"],
      jyjgdl:["救援机构登录成功","en_translated"],
      jjgjgd:["监管机构登录成功","en_translated"],
      dlsbgy:["登录失败，该用户不属于监管机构","en_translated"],
      dlsbyh:["登录失败，用户名或密码错误","en_translated"],
      dlsbwz:["登录失败，未知错误","en_translated"],
      fxfbh:["分销系统","Distribution platform"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/components/header/indexHeader.vue.trans.js